import { defineStore } from 'pinia'
import { useStore } from '.'
import { getAssets } from '~/apis/finance'

export const useFinanceStore = defineStore('finance', {
  state: () => ({
    assets: {},
  }),
  getters: {
    getBanlanceByType() {
      const { spotCurrenciesRaw } = useStore()
      return ({ type = 'total', unit = 'usdt', id, code, accountType }) => {
        if ((code || id) && type !== 'total') {
          id ??= spotCurrenciesRaw[code]?.id
          return this.assets[type]?.list.find(i => +i.currencyId === id && (i.accountType === (accountType ?? i.accountType))) ?? {}
        }
        else {
          unit = `to${unit.at(0).toUpperCase()}${unit.substring(1)}`
          return this.assets[type]?.[unit] ?? 0
        }
      }
    },
  },
  actions: {
    async getAssets() {
      const { success, data } = await getAssets()
      if (success) {
        this.assets = {
          ...data,
          future: {
            ...data.contractAsset,
            list: data.contractAsset.contractsAmount.map(i => ({ ...i, trade: i.available })),
            toUsdt: data.contractAsset.toUsdt,
            toBtc: data.contractAsset.toBtc,
            toUsd: data.contractAsset.toUsd,
          },
          spot: {
            ...data.spotAsset,
            list: data.spotAsset.assets.map(i => ({ ...i, trade: i.usableAmount })),
            toUsdt: data.spotAsset.usdtValuation,
            toBtc: data.spotAsset.btcValuation,
            toUsd: data.spotAsset.usdValuation,
          },
          total: {
            toUsdt: data.totalUsdtBalance,
            toBtc: data.totalBalance,
            toUsd: data.totalUsdBalance,
          },
        }
      }
    },
  },
})
